// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSHeader/ABSInvitation/InvitationCard.less
// module id = 753
// module chunks = 42